module.exports = __webpack_public_path__ + "static/img/tup2.1eeae64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/tup2.png
// module id = 3YGH
// module chunks = 0